<template>
  <div class="announcement-page anim-fade-in-up">
    <!-- 搜索栏 -->
    <div class="content-card" style="padding: 14px 20px; margin-bottom: 18px;">
      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item>
          <el-input v-model="searchForm.keyword" placeholder="搜索公告标题..." clearable @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 公告列表 -->
    <div class="content-card" style="padding: 4px 20px;">
      <div v-if="loading" style="text-align: center; padding: 48px 0; color: var(--text-muted);"><i class="el-icon-loading"></i> 加载中...</div>
      <div v-else-if="tableData.length === 0" class="empty-tip">
        <i class="el-icon-document" style="font-size: 36px;"></i>
        <p>暂无公告</p>
      </div>
      <div v-else v-for="item in tableData" :key="item.id" class="announce-item" @click="showDetail(item)">
        <div class="announce-header">
          <span class="announce-title">{{ item.title }}</span>
          <span class="announce-meta">{{ item.publisher }} · {{ item.createTime ? item.createTime.replace('T',' ').substring(0,16) : '' }}</span>
        </div>
        <p class="announce-preview">{{ (item.content || '').substring(0, 120) }}{{ (item.content || '').length > 120 ? '...' : '' }}</p>
      </div>
    </div>

    <!-- 分页 -->
    <div v-if="total > 0" class="pagination-wrap">
      <el-pagination
        background
        :current-page="searchForm.page"
        :page-size="searchForm.pageSize"
        :total="total"
        layout="total, prev, pager, next"
        @current-change="v => { searchForm.page = v; fetchList(); }"
      />
    </div>

    <!-- 详情对话框 -->
    <el-dialog :visible.sync="detailVisible" :title="currentItem.title" width="600px" append-to-body :close-on-click-modal="false">
      <p style="color: var(--text-secondary); white-space: pre-wrap; line-height: 1.8;">{{ currentItem.content }}</p>
      <div slot="footer" style="font-size: 0.8rem; color: var(--text-muted);">
        {{ currentItem.publisher }} · {{ currentItem.createTime ? currentItem.createTime.replace('T',' ').substring(0,16) : '' }}
      </div>
    </el-dialog>

  </div>
</template>

<style scoped>
.page-title {
  font-family: var(--font-display);
  font-size: 1.5rem; font-weight: 500;
  color: var(--text-primary); margin: 0 0 20px; letter-spacing: 0.04em;
}

.content-card {
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
}

.announce-item {
  padding: 16px 0;
  border-bottom: 1px solid var(--border-subtle);
  cursor: pointer;
  transition: background var(--transition-fast);
}
.announce-item:hover {
  background: var(--accent-primary-soft);
  margin: 0 -20px; padding: 16px 20px;
  border-radius: var(--radius-sm);
}
.announce-item:last-child { border-bottom: none; }
.announce-header { display: flex; justify-content: space-between; align-items: center; }
.announce-title { font-size: 0.95rem; font-weight: 600; color: var(--text-primary); }
.announce-meta {
  font-size: 0.72rem; color: var(--text-muted);
  font-family: var(--font-mono); white-space: nowrap;
}
.announce-preview {
  font-size: 0.84rem; color: var(--text-secondary);
  margin: 8px 0 0; line-height: 1.6;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}

.pagination-wrap { margin-top: 18px; text-align: right; }
.empty-tip { text-align: center; padding: 56px 0; color: var(--text-muted); }
</style>

<script>
export default {
  data() {
    return {
      searchForm: { keyword: '', page: 1, pageSize: 10 },
      tableData: [], total: 0, loading: false,
      detailVisible: false, currentItem: {}
    }
  },
  created() { this.fetchList(); },
  methods: {
    async fetchList() {
      this.loading = true;
      try {
        const resp = await this.$axios.get('/user/announcement/list', { params: this.searchForm });
        if (resp.data.code === 0) { const d = resp.data.data; this.tableData = d.list || []; this.total = d.total || 0; }
      } catch (e) { console.error(e); } finally { this.loading = false; }
    },
    handleSearch() { this.searchForm.page = 1; this.fetchList(); },
    handleReset() { this.searchForm = { keyword: '', page: 1, pageSize: 10 }; this.fetchList(); },
    showDetail(item) { this.currentItem = item; this.detailVisible = true; }
  }
}
</script>
